import { jsxs, jsx, Fragment } from "../../../node_modules/@emotion/react/jsx-runtime/dist/emotion-react-jsx-runtime.browser.esm.es.js";
import { Alignment } from "../../foundations/alignment.es.js";
import { Displaying } from "../../foundations/displaying.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/react/jsx-runtime.es.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/react/dist/emotion-element-c39617d8.browser.esm.es.es.js";
import "react";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/hoist-non-react-statics/dist/hoist-non-react-statics.cjs.es.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/node_modules/@emotion/serialize/dist/emotion-serialize.browser.esm.es.es.js";
import { styled } from "@mui/material";
import { InfoCircleOutlined as t } from "../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/outlined/info-circle-outlined.es.es.js";
import { PlusOutlined as l } from "../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/outlined/plus-outlined.es.es.js";
import "../../../node_modules/@bonusx-global/bx-icons/dist/src/icons/solid/turn-icons.es.es.js";
import Box from "../../../node_modules/@mui/material/Box/Box.es.js";
import { GridContainer, SupportedFilesTextContainer, UploaderContainer, DividerContainer, infoIconStyle, SupportedFilesTypographyContainer } from "./styles/container.es.js";
import { Tabs } from "../tabs/tabs.es.js";
import { Tab } from "../tabs/tab.es.js";
import Grid from "../../../node_modules/@mui/material/Grid/Grid.es.js";
import { UploaderTabRenderer } from "./components/tab-renderer.es.js";
import { Typography } from "../typography/typography.es.js";
import { Button } from "../button/button.es.js";
const BoxCentered = styled(Box)({
  display: Displaying.flex,
  justifyContent: Alignment.center
});
function Uploader({
  isMobile,
  addButtonText,
  title,
  disableAddButton,
  isAddButtonVisible = true,
  supportedFilesText,
  elevated,
  tabs,
  addNewTab,
  removeTab,
  isActionButtonVisible,
  onClickUploadEntireDocument,
  activeTabIndex,
  setActiveTabIndex,
  actionButtonText,
  onDrop,
  scrollButtons,
  tabsFullWidth,
  canModifyDocument,
  onClickModifyDocument,
  ...rest
}) {
  return /* @__PURE__ */ jsxs(UploaderContainer, { isMobile, elevated, ...rest, children: [
    title ? /* @__PURE__ */ jsx(Typography, { variant: "body2", children: title }) : /* @__PURE__ */ jsx(Fragment, {}),
    /* @__PURE__ */ jsxs(GridContainer, { container: true, isMobile, children: [
      /* @__PURE__ */ jsx(Grid, { item: true, sx: {
        width: tabsFullWidth ? "100%" : "initial"
      }, children: /* @__PURE__ */ jsx(Tabs, { scrollButtons, value: activeTabIndex, onChange: (_event, newValue) => setActiveTabIndex(newValue), children: tabs.map(function renderTab(tab, _) {
        return /* @__PURE__ */ jsx(Tab, { label: tab.label, "data-testid": `tab-${tab.id}` }, tab.id);
      }) }) }),
      isAddButtonVisible && /* @__PURE__ */ jsx(Grid, { item: true, children: /* @__PURE__ */ jsxs(GridContainer, { container: true, isMobile, sx: {
        paddingBottom: "0"
      }, children: [
        /* @__PURE__ */ jsx(Grid, { item: true, children: /* @__PURE__ */ jsx(DividerContainer, { isMobile, orientation: "vertical", variant: "middle" }) }),
        /* @__PURE__ */ jsx(Grid, { item: true, children: /* @__PURE__ */ jsx(Button, { "data-testid": "add-tab-button", disabled: disableAddButton ?? false, onClick: addNewTab, endIcon: /* @__PURE__ */ jsx(l, {}), children: addButtonText ?? "Add" }) })
      ] }) })
    ] }),
    /* @__PURE__ */ jsx(Box, { children: tabs.map(function renderSelectedTab(tab, _) {
      return /* @__PURE__ */ jsx(UploaderTabRenderer, { onDrop, tab, tabs, activeTabIndex, onRemoveTab: removeTab, setActiveTabIndex });
    }) }),
    isActionButtonVisible && /* @__PURE__ */ jsx(BoxCentered, { children: /* @__PURE__ */ jsx(Button, { size: "small", variant: "contained", onClick: canModifyDocument ? onClickModifyDocument : onClickUploadEntireDocument, children: actionButtonText }) }),
    /* @__PURE__ */ jsxs(SupportedFilesTextContainer, { children: [
      /* @__PURE__ */ jsx(t, { sx: infoIconStyle }),
      /* @__PURE__ */ jsx(SupportedFilesTypographyContainer, { children: supportedFilesText ?? "Supported files PDF, JPG. Max 1 Mb" })
    ] })
  ] });
}
export {
  Uploader
};
//# sourceMappingURL=uploader.es.js.map
